const preloadImageToBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result.toString());
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
const preloadPinImages = async (pins, globalImages) => {
  const uniqueUrls = /* @__PURE__ */ new Set();
  pins.forEach((pin) => {
    var _a, _b, _c;
    if ((_a = pin.placemark) == null ? void 0 : _a.default) {
      uniqueUrls.add(pin.placemark.default);
    }
    if ((_b = pin.placemark) == null ? void 0 : _b.hover) {
      uniqueUrls.add(pin.placemark.hover);
    }
    if ((_c = pin.placemark) == null ? void 0 : _c.active) {
      uniqueUrls.add(pin.placemark.active);
    }
  });
  if (globalImages == null ? void 0 : globalImages.default) {
    uniqueUrls.add(globalImages.default);
  }
  if (globalImages == null ? void 0 : globalImages.hover) {
    uniqueUrls.add(globalImages.hover);
  }
  if (globalImages == null ? void 0 : globalImages.active) {
    uniqueUrls.add(globalImages.active);
  }
  const cache = {};
  await Promise.all(
    Array.from(uniqueUrls).map(async (url) => {
      try {
        const base64 = await preloadImageToBase64(url);
        cache[url] = base64;
      } catch (err) {
        console.warn("Failed to preload:", url);
      }
    })
  );
  return cache;
};
const getMapStyles = async (styles) => {
  if (!styles) {
    return [];
  }
  if (typeof styles !== "string") {
    return styles;
  }
  try {
    const res = await fetch(styles);
    const styleObjects = await res.json();
    return styleObjects;
  } catch (error) {
    console.warn("UIkit. Не удалось получить данные о стилях карты", error);
    return [];
  }
};
export {
  getMapStyles,
  preloadImageToBase64,
  preloadPinImages
};
//# sourceMappingURL=Map.utils.js.map
